/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Document,
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentItemPage
 */
export interface DocumentItemPage {
    /**
     * 
     * @type {Array<Document>}
     * @memberof DocumentItemPage
     */
    items?: Array<Document> | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentItemPage
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentItemPage
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentItemPage
     */
    itemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentItemPage
     */
    totalItemCount?: number;
}

export function DocumentItemPageFromJSON(json: any): DocumentItemPage {
    return DocumentItemPageFromJSONTyped(json, false);
}

export function DocumentItemPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentItemPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(DocumentFromJSON)),
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'currentPage': !exists(json, 'currentPage') ? undefined : json['currentPage'],
        'itemsPerPage': !exists(json, 'itemsPerPage') ? undefined : json['itemsPerPage'],
        'totalItemCount': !exists(json, 'totalItemCount') ? undefined : json['totalItemCount'],
    };
}

export function DocumentItemPageToJSON(value?: DocumentItemPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(DocumentToJSON)),
        'totalPages': value.totalPages,
        'currentPage': value.currentPage,
        'itemsPerPage': value.itemsPerPage,
        'totalItemCount': value.totalItemCount,
    };
}


